
// Main export file for the armpit pain and lymph nodes article data
import { armpitPainLymphNodesMetadata } from './metadata';
import { armpitPainLymphNodesContent } from './content';
import { armpitPainLymphNodesSources } from './sources';
import { armpitPainLymphNodesRecommendedProducts } from './recommended-products';
import { armpitPainLymphNodesRelatedArticles } from './related-articles';

export const armpitPainLymphNodesArticle = {
  ...armpitPainLymphNodesMetadata,
  content: armpitPainLymphNodesContent,
  sources: armpitPainLymphNodesSources,
  recommendedProducts: armpitPainLymphNodesRecommendedProducts,
  relatedArticles: armpitPainLymphNodesRelatedArticles
};
